import { authHeader } from '@/helpers';

export const accountService = {
  getUsers,
  getRoles,
  create,
  update,
  remove,
  resetPassword
};

async function getUsers(appId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  const query = appId ? `?appId=${appId}` : '';
  return fetch(`${process.env.VUE_APP_APIURL}/account/get${query}`, requestOptions)
    .then((response) => response.json())
    .then(responseJson => {
      return responseJson;
    });
}

async function getRoles() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.VUE_APP_APIURL}/account/getroles`, requestOptions)
    .then((response) => response.json())
    .then(responseJson => {
      return responseJson;
    });
}

async function create(user) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(user)
  };

  return fetch(`${process.env.VUE_APP_APIURL}/account/create`, requestOptions);
}

async function update(user) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(user)
  };

  return fetch(`${process.env.VUE_APP_APIURL}/account/put`, requestOptions);
}

async function remove(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };

  return fetch(`${process.env.VUE_APP_APIURL}/account/delete?id=${id}`, requestOptions);
}

async function resetPassword(dto) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(dto)
  };

  return fetch(`${process.env.VUE_APP_APIURL}/account/adminresetpassword`, requestOptions);
}
